function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr2TogR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.880121mm",
    height: "20.051638mm",
    viewBox: "0 0 10.880121 20.051638",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113.82455,-104.22342)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 121.69835,123.78208 V 104.74376 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 114.32206,123.72362 7.30558,-19.00675 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 124.21168,112.32753 h -9.05239 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 124.21169,114.75668 h -9.0524 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr2TogR);
export default __webpack_public_path__ + "static/media/tr2tog-r.df29c2a1d87a0ced232109e0323ed692.svg";
export { ForwardRef as ReactComponent };